/**
 * Lógica pura de la pestaña Conversación (sin React), 2026-10-21: orden de la lista de
 * conversaciones y opciones de filtro de la vista única de avisos.
 */
import type { PendingAlert, SessionRow } from './shared';

/**
 * Lista de conversaciones como la ve el dueño: primero las que tienen avisos pendientes (más
 * avisos primero), después el resto por última actividad. `onlyWithAlerts` deja solo las primeras.
 */
export function sortSessionsForList(sessions: SessionRow[], onlyWithAlerts: boolean): SessionRow[] {
  const rows = onlyWithAlerts ? sessions.filter((s) => (s.alerts_new ?? 0) > 0) : sessions.slice();
  return rows.sort((a, b) => {
    const d = (b.alerts_new ?? 0) - (a.alerts_new ?? 0);
    if (d !== 0) return d;
    return String(b.last_at ?? '').localeCompare(String(a.last_at ?? ''));
  });
}

export interface FilterOption {
  value: string;
  label: string;
  count: number;
}

/** Empresas presentes en los avisos cargados (valor = id de empresa), con cuántos avisos cada una. */
export function sellerOptions(items: PendingAlert[]): FilterOption[] {
  const m = new Map<string, FilterOption>();
  for (const a of items) {
    const k = String(a.seller_id);
    const cur = m.get(k) ?? { value: k, label: a.seller_name || `Empresa ${k}`, count: 0 };
    cur.count++;
    m.set(k, cur);
  }
  return [...m.values()].sort((x, y) => x.label.localeCompare(y.label));
}

/** Tipos de aviso presentes (valor = kind, texto = etiqueta en español), con cuántos de cada uno. */
export function kindOptions(items: PendingAlert[]): FilterOption[] {
  const m = new Map<string, FilterOption>();
  for (const a of items) {
    const cur = m.get(a.kind) ?? { value: a.kind, label: a.label || a.kind, count: 0 };
    cur.count++;
    m.set(a.kind, cur);
  }
  return [...m.values()].sort((x, y) => y.count - x.count);
}
